import React from 'react';
import './WeChatGuide.css';

interface WeChatGuideProps {
    visible: boolean;
}

export const WeChatGuide: React.FC<WeChatGuideProps> = ({ visible }) => {
    if (!visible) return null;

    return (
        <div className="wechat-guide-overlay">
            {/* 右上角三个点 */}
            <div className="wechat-guide-dots">
                <div className="wechat-guide-dot"></div>
                <div className="wechat-guide-dot"></div>
                <div className="wechat-guide-dot"></div>
            </div>

            {/* 箭头动画 - 指向右上角 */}
            <div className="wechat-guide-arrow">
                <svg viewBox="0 0 100 120" preserveAspectRatio="xMidYMid meet">
                    {/* 弯曲的箭头路径，指向右上角 */}
                    <path
                        className="wechat-guide-arrow-path"
                        d="M 20 100 Q 30 60, 60 40 L 55 45 M 60 40 L 50 35 M 60 40 L 58 50"
                    />
                    {/* 更明显的箭头 */}
                    <path
                        className="wechat-guide-arrow-path"
                        d="M 25 95 Q 35 55, 70 30"
                        style={{ animationDelay: '0.2s' }}
                    />
                    <path
                        className="wechat-guide-arrow-path"
                        d="M 65 35 L 75 25 M 70 30 L 60 25 M 70 30 L 68 40"
                        style={{ animationDelay: '0.4s' }}
                    />
                </svg>
            </div>

            <div className="wechat-guide-content">
                <div className="wechat-guide-icon">📱</div>
                <h2 className="wechat-guide-title">请在浏览器中打开</h2>
                <p className="wechat-guide-text">
                    微信内置浏览器不支持部分功能<br />
                    请点击右上角，选择"在浏览器打开"
                </p>

                <div className="wechat-guide-steps">
                    <div className="wechat-guide-step">
                        <span className="wechat-guide-step-number">1</span>
                        <span>点击右上角「···」按钮</span>
                    </div>
                    <div className="wechat-guide-step">
                        <span className="wechat-guide-step-number">2</span>
                        <span>选择「在浏览器打开」</span>
                    </div>
                    <div className="wechat-guide-step">
                        <span className="wechat-guide-step-number">3</span>
                        <span>使用系统浏览器访问本页面</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeChatGuide;
